// v050-g5 (B-506, B-507) — décisions d'architecture (ADR du projet et de l'outil), matrice
// de comparaison, catalogue des cinq piles d'ADR-0109 et profil de pile du projet.
import { request } from './http'
import type {
  AdrCreate, AdrCriterionInput, AdrDetail, AdrOptionInput, AdrPatch, AdrScoreInput, AdrSummary,
  ProjectStackProfile, StackCatalogEntry, StackQualificationInput,
} from './types/decisions'

export const decisionsApi = {
  listProjectAdrs: (workspaceId: string) =>
    request<AdrSummary[]>(`/workspaces/${encodeURIComponent(workspaceId)}/adrs`),

  createProjectAdr: (workspaceId: string, body: AdrCreate) =>
    request<AdrDetail>(`/workspaces/${encodeURIComponent(workspaceId)}/adrs`,
      { method: 'POST', body: JSON.stringify(body) }),

  /** B-507 : les décisions de l'outil lui-même. */
  listToolAdrs: () => request<AdrSummary[]>('/tool-adrs'),

  createToolAdr: (body: AdrCreate) =>
    request<AdrDetail>('/tool-adrs', { method: 'POST', body: JSON.stringify(body) }),

  getAdr: (adrId: number) => request<AdrDetail>(`/adrs/${adrId}`),

  updateAdr: (adrId: number, patch: AdrPatch) =>
    request<AdrDetail>(`/adrs/${adrId}`, { method: 'PATCH', body: JSON.stringify(patch) }),

  addAdrOption: (adrId: number, option: AdrOptionInput) =>
    request<AdrDetail>(`/adrs/${adrId}/options`, { method: 'POST', body: JSON.stringify(option) }),

  addAdrCriterion: (adrId: number, criterion: AdrCriterionInput) =>
    request<AdrDetail>(`/adrs/${adrId}/criteria`, { method: 'POST', body: JSON.stringify(criterion) }),

  /** Refusé par le serveur (`ADR_WEIGHTS_FROZEN`) dès la première note. */
  updateAdrCriterion: (adrId: number, criterionId: number, change: { label?: string; weight?: number }) =>
    request<AdrDetail>(`/adrs/${adrId}/criteria/${criterionId}`,
      { method: 'PUT', body: JSON.stringify(change) }),

  scoreAdrOption: (adrId: number, score: AdrScoreInput) =>
    request<AdrDetail>(`/adrs/${adrId}/scores`, { method: 'POST', body: JSON.stringify(score) }),

  reviewAdr: (adrId: number, verdict: 'approve' | 'reject', comment: string) =>
    request<AdrDetail>(`/adrs/${adrId}/review`, { method: 'POST', body: JSON.stringify({ verdict, comment }) }),

  decideAdr: (adrId: number, optionId: number, decision: string, comment?: string) =>
    request<AdrDetail>(`/adrs/${adrId}/decide`, {
      method: 'POST',
      body: JSON.stringify({ option_id: optionId, decision, ...(comment ? { comment } : {}) }),
    }),

  listStacks: () => request<StackCatalogEntry[]>('/stacks'),

  /** Enregistre une qualification MESURÉE (administrateur de plateforme ; FND-V050-082). */
  qualifyStack: (stackId: string, qualification: StackQualificationInput) =>
    request<StackCatalogEntry>(`/stacks/${encodeURIComponent(stackId)}/qualifications`, {
      method: 'POST', body: JSON.stringify(qualification),
    }),

  projectStackProfile: (workspaceId: string) =>
    request<ProjectStackProfile>(`/workspaces/${encodeURIComponent(workspaceId)}/stack-profile`),
}
